// src/components/Auth/ForgotPassword.js
import React, { useState } from 'react';
import { AuthContainer, AuthBox, InputField, Button, Title, ErrorMessage } from '../../styles/AuthStyles';
import { useNavigate } from 'react-router-dom'; // Updated import
import axios from 'axios';
import { API_BASE_URL } from '../../config/config';

const ForgotPassword = () => {
  const [userId, setUserId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate(); // Updated hook

  const handleSendOTP = async () => {
    setError('');

    if (!userId.trim()) {
      setError('Please enter your UserID.');
      return;
    }

    setLoading(true);
    
    try {
      const response = await axios.post(`${API_BASE_URL}api/users/initiate`, { userId });
      if (response.data.message) {
        // Navigate to VerifyOTP screen, passing userId via state
        navigate('/verify-otp', { state: { userId } });
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
      <AuthBox>
        <Title>Forgot Password</Title>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <InputField
          type="text"
          placeholder="Enter your UserID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <Button onClick={handleSendOTP} disabled={loading}>
          {loading ? 'Sending...' : 'Send OTP'}
        </Button>
      </AuthBox>
    </AuthContainer>
  );
};

export default ForgotPassword;
